import { AloftDate, isDefined } from '@aloft/toolkit-shared';

import { Flex } from '../../../summary/components/Flex.js';
import { CostApproachSummarySourceLine } from './CostApproachSummarySourceLine.tsx';

export const CostApproachSummarySource = ({
  source,
  quality,
  physicalDepreciation,
  ...props
}: {
  source?: {
    name?: string;
    effectiveDate?: AloftDate;
  };
  quality?: string;
  physicalDepreciation?: { effectiveAge?: number; ecoLifeYears?: number };
}) => {
  const remainingLife =
    isDefined(physicalDepreciation) &&
    isDefined(physicalDepreciation?.ecoLifeYears) &&
    isDefined(physicalDepreciation?.effectiveAge)
      ? physicalDepreciation.ecoLifeYears - physicalDepreciation.effectiveAge
      : undefined;

  return (
    <Flex flexDirection="column">
      <CostApproachSummarySourceLine
        value={`Source of cost data: ${source?.name ?? 'unknown'}`}
        {...props}
      />
      <CostApproachSummarySourceLine
        value={`Effective date of cost data: ${
          source?.effectiveDate ? source.effectiveDate.toIsoString() : 'unknown'
        }`}
        {...props}
      />
      {quality && (
        <CostApproachSummarySourceLine
          value={`Quality rating from cost service: ${quality}`}
          {...props}
        />
      )}
      {isDefined(remainingLife) && (
        <CostApproachSummarySourceLine
          value={`Est remaining economic life: ${remainingLife.toString()} ${
            remainingLife === 1 ? 'year' : 'years'
          }`}
          {...props}
        />
      )}
    </Flex>
  );
};
